var voted_users_rtlignore_default = {
  "container": "f14I3",
  "webview": "fMmbo",
  "avatar_list": "_8T40D",
  "avatar": "y-sNU",
  "user_avatar": "v3YzB",
  "modal": "wl3IS",
  "voted_users_modal": "vxfHK",
  "overlay": "_6l6gi",
  "user_card": "l3blk",
  "user_name": "_2x0i-",
  "voted_users_modal_header": "mE4vq",
  "cta": "DUCJJ",
  "close_icon": "ggNdK",
  "title": "l-S2l",
  "member_list_container": "BYlKR",
  "member_list": "dcK1Q",
  "loader": "fw6Zv",
  "anonymous_counter": "Ep3ka",
  "spinner": "iqrpf",
  "spin": "x275x"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
